<div class="payment-selection-holder">
    <app-credit-card-selection
        (onSubmitCard)="onCardSelection($event, 'pay-with-defined-card')"
    ></app-credit-card-selection>
    <!-- <div class="pay-w-defined-card" (click)="onPaymentTypeSelect('pay-with-defined-card')">
        <div class="card-icon">
            <img src="../../../../assets/images/widget_card.png"/>
        </div>
       <div class="card-type-info">Pay with Defined Card</div>
    </div> -->
    <div class="pay-w-credit-card" (click)="onPaymentTypeSelect('pay-with-credit-card')">
        <div class="card-icon">
            <img src="../../../../assets/images/widget_card.png"/>
        </div>
        <div class="card-type-info">{{ 'CARDOPERATIONS_PAY_WITH_CREDITCARD_LABEL' | translate }}</div>
    </div>
</div>